import Grid from '@app/components/common/Grid';

import { displayFlexEndColumnStyles } from '@app/theme/commonStyles';
import { WithTranslation } from 'react-i18next';
import { payHoursSubsection } from './styles';
import MoneyInput from '@app/components/common/MoneyInput';

const PayHours = ({ t }: WithTranslation) => {
  return (
    <Grid columnGap={20} rowGap={15}>
      <Grid.Item mb={12} sm={12} md={12} xl={6} csx={[payHoursSubsection]}>
        <Grid columnGap={20} rowGap={15}>
          <Grid.Item
            mb={12}
            sm={6}
            md={6}
            xl={6}
            csx={displayFlexEndColumnStyles}>
            <MoneyInput
              label={t(
                'settingsModule.generalSettings.payHours.weeklyHours.label',
              )}
              placeholder={t(
                'settingsModule.generalSettings.payHours.weeklyHours.label',
              )}
              value={40}
              onValueChange={() => null}
              prefix=""
              precision={0}
            />
          </Grid.Item>
          <Grid.Item
            mb={12}
            sm={6}
            md={6}
            xl={6}
            csx={displayFlexEndColumnStyles}>
            <MoneyInput
              label={t(
                'settingsModule.generalSettings.payHours.weeklyOvertimeFactor.label',
              )}
              placeholder={t(
                'settingsModule.generalSettings.payHours.weeklyOvertimeFactor.label',
              )}
              value={1.5}
              onValueChange={() => null}
              prefix=""
              precision={1}
            />
          </Grid.Item>
        </Grid>
      </Grid.Item>

      <Grid.Item mb={12} sm={12} md={12} xl={6}>
        <Grid columnGap={20} rowGap={15}>
          <Grid.Item
            mb={12}
            sm={6}
            md={6}
            xl={6}
            csx={displayFlexEndColumnStyles}>
            <MoneyInput
              label={t(
                'settingsModule.generalSettings.payHours.dailyHours.label',
              )}
              placeholder={t(
                'settingsModule.generalSettings.payHours.dailyHours.label',
              )}
              value={8}
              onValueChange={() => null}
              prefix=""
              precision={0}
            />
          </Grid.Item>
          <Grid.Item
            mb={12}
            sm={6}
            md={6}
            xl={6}
            csx={displayFlexEndColumnStyles}>
            <MoneyInput
              label={t(
                'settingsModule.generalSettings.payHours.dailyOvertimeFactor.label',
              )}
              placeholder={t(
                'settingsModule.generalSettings.payHours.dailyOvertimeFactor.label',
              )}
              value={1.2}
              onValueChange={() => null}
              prefix=""
              precision={1}
            />
          </Grid.Item>
        </Grid>
      </Grid.Item>
    </Grid>
  );
};

export default PayHours;
